import {
  LBButton,
  LBTable,
  LBTableHeader,
  LBTableBody,
  LBTableRow,
  LBTableHead,
  LBChevronUpIcon,
  LBChevronDownIcon,
  LBTooltip,
  LBTooltipTrigger,
  LBTooltipContent,
  LBInfoCircleIcon
} from '@linearb/buzz'

const CustomTable = ({
  tableRows,
  columns,
  tableWidth = '100%',
  onSort = null,
  sortConfig = null
}) => {
  const getSortIcon = sortKey => {
    if (!sortConfig || sortConfig.key !== sortKey) {
      return null
    }
    return sortConfig.direction === 'asc' ? (
      <LBChevronUpIcon className='inline-block ml-1 h-4 w-4' />
    ) : (
      <LBChevronDownIcon className='inline-block ml-1 h-4 w-4' />
    )
  }

  return (
    <LBTable style={{ width: tableWidth }}>
      <LBTableHeader>
        <LBTableRow>
          {columns.map(
            (
              { title, width, sortKey, tooltip, align, wrapTitle, headerIcon },
              index
            ) => {
              const sortable = Boolean(sortKey && onSort)
              // A real button gives keyboard + screen-reader access; its click bubbles to the th
              const Label = sortable ? LBButton : 'span'
              return (
                <LBTableHead
                  key={title || index}
                  style={{ width }}
                  onClick={sortable ? () => onSort(sortKey) : undefined}
                  aria-sort={
                    sortKey && sortConfig?.key === sortKey
                      ? sortConfig.direction === 'asc'
                        ? 'ascending'
                        : 'descending'
                      : undefined
                  }
                  className={[
                    sortable
                      ? 'cursor-pointer select-none no-underline hover:no-underline'
                      : '',
                    align === 'right' ? 'text-right' : ''
                  ]
                    .filter(Boolean)
                    .join(' ')}
                >
                  {/* nowrap sets the column's min width to the full title, so long
                  titles over narrow content need wrapTitle to not widen the table */}
                  <Label
                    {...(sortable && { type: 'button', variant: 'ghost' })}
                    className={`inline-flex items-center${
                      wrapTitle ? ' whitespace-normal' : ' whitespace-nowrap'
                    }${
                      sortable
                        ? ' h-auto gap-0 rounded-sm p-0 font-medium text-inherit hover:bg-transparent hover:text-inherit'
                        : ''
                    }`}
                  >
                    {title}
                    {headerIcon}
                    {tooltip && (
                      <LBTooltip>
                        <LBTooltipTrigger
                          asChild
                          onClick={e => e.stopPropagation()}
                        >
                          <LBInfoCircleIcon className='ml-1 h-3.5 w-3.5 shrink-0 text-muted-foreground' />
                        </LBTooltipTrigger>
                        <LBTooltipContent>
                          {tooltip.split('\n').map((line, i) => (
                            <div key={i}>{line}</div>
                          ))}
                        </LBTooltipContent>
                      </LBTooltip>
                    )}
                    {sortKey && getSortIcon(sortKey)}
                  </Label>
                </LBTableHead>
              )
            }
          )}
        </LBTableRow>
      </LBTableHeader>
      <LBTableBody>{tableRows}</LBTableBody>
    </LBTable>
  )
}

export default CustomTable
